import { useAccountBadgeActionChecks, } from '../../../../ui/features/badge-management/hooks/useAccountBadgeActionChecks';
import { useAccountBadgeNotifyBulkAction } from '../../../../ui/features/badge-management/hooks/useAccountBadgeNotifyBulkAction';
import { useAccountBadgePrintBulkAction } from '../../../../ui/features/badge-management/hooks/useAccountBadgePrintBulkAction';
import { useAddAccountBadgeAction } from '../../../../ui/features/badge-management/hooks/useAddAccountBadgeAction';
import { useAccountBadgeEditDistributionBulkAction } from './useAccountBadgeEditDistributionBulkAction';
import { useAccountBadgeReissueBulkAction } from './useAccountBadgeReissueBulkAction';
import { useAccountBadgeRevokeBulkAction } from './useAccountBadgeRevokeBulkAction';
/**
 * Centralized place for all multi Account Badge bulk-actions
 */
export function useAccountBadgeBulkActions({ badgeId, accountBadgesAll, accountBadgeRows, accountBadgeSelectedIds, onActionCompleted, appliedStorageFilters, filteredRowCount, }) {
    const accountBadgesSelected = accountBadgeRows.filter((row) => accountBadgeSelectedIds.includes(row.id));
    const checks = useAccountBadgeActionChecks({ accountBadgesSelected });
    const { handleAddAccount } = useAddAccountBadgeAction({
        badgeId,
        accountBadgesAll,
        accountBadgeRows,
        accountBadgeSelectedIds,
        onActionCompleted,
    });
    const { handleReissueAccountBadgesBulkActionDialog } = useAccountBadgeReissueBulkAction();
    const { handleChangeDistributionStatus } = useAccountBadgeEditDistributionBulkAction({
        badgeId,
        accountBadgeSelectedIds,
        onClose: onActionCompleted,
        appliedStorageFilters,
        filteredRowCount,
    });
    const { handleRevoke } = useAccountBadgeRevokeBulkAction({
        badgeId,
        accountBadgeSelectedIds,
        onClose: onActionCompleted,
        appliedStorageFilters,
        filteredRowCount,
    });
    const { handleNotify } = useAccountBadgeNotifyBulkAction({
        badgeId,
        accountBadgeSelectedIds,
        appliedStorageFilters,
    });
    const { handlePrintAccountBadges } = useAccountBadgePrintBulkAction({
        badgeId,
        accountBadgeSelectedIds,
        onClose: onActionCompleted,
        appliedStorageFilters,
        filteredRowCount,
    });
    return Object.assign(Object.assign({}, checks), { canAddAccount: true, handleAddAccount, handleReissueAccountBadgesBulkActionDialog: () => {
            handleReissueAccountBadgesBulkActionDialog(badgeId, appliedStorageFilters, accountBadgeSelectedIds, onActionCompleted);
        }, handleChangeDistributionStatus,
        handlePrintAccountBadges,
        handleRevoke, handleNotify: () => void handleNotify() });
}
